// extracted by mini-css-extract-plugin
export default {"message_heading":"Accordian_message_heading__QUJri","acc":"Accordian_acc__6pfQk"};